var _line, _line2, _line3, _line4, _line5, _line6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceListItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15.5,
    x2: 16,
    y2: 15.5,
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 16,
    y2: 12,
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8.5,
    x2: 16,
    y2: 8.5,
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 15.5,
    x2: 12,
    y2: 15.5,
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 12,
    y2: 12,
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8.5,
    x2: 12,
    y2: 8.5,
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,19.425V4.575a1,1,0,0,0-.49794-.86483l-.99047-.575a1,1,0,0,0-.99809-.00348l-1.51928.86791L14.50611,3.136a1,1,0,0,0-1.00047-.002L12,4l-1.50564-.8659A1,1,0,0,0,9.49388,3.136l-1.48811.86359-1.51929-.8679a1,1,0,0,0-.99808.00348l-.99047.575A1,1,0,0,0,4,4.575v14.85a1,1,0,0,0,.49793.86483l.99047.575a1,1,0,0,0,.99809.00348l1.51929-.86791,1.48811.86359a1,1,0,0,0,1.00047.00195L12,20l1.50565.8659a1,1,0,0,0,1.00047-.002l1.4881-.86358,1.51929.8679a1,1,0,0,0,.99809-.00348l.99046-.575A1,1,0,0,0,20,19.425Z",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceListItem);
export default __webpack_public_path__ + "static/media/invoice-list-item.df12736263ecfb8d02af426a8edab8eb.svg";
export { ForwardRef as ReactComponent };